module.exports = __webpack_public_path__ + "eb439115.svg";